var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIconCrisp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.216.18a1.3 1.3 0 0 1 1.302 1.3v5.434h5.435a1.302 1.302 0 0 1 0 2.604H9.518v5.434a1.302 1.302 0 0 1-2.603 0V9.52H1.48a1.303 1.303 0 0 1-.92-2.222 1.3 1.3 0 0 1 .92-.382h5.434V1.481A1.303 1.303 0 0 1 8.216.18Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.358
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconCrisp);
export default __webpack_public_path__ + "static/media/plusIconCrisp.4526440951651ee31ba4d6c28e2a8986.svg";
export { ForwardRef as ReactComponent };